import { v4 as uuid } from "uuid";

export const isNotLocalUrl = (url: string): boolean => {
  return (
    !url.endsWith("/auth/forgot-password") &&
    !url.endsWith("/auth/login") &&
    !url.endsWith("/auth/register") &&
    !url.includes("/auth/") &&
    !url.includes("/api/v2/") &&
    !url.includes(".apple.com") &&
    !url.includes(".facebook.com")
  );
};

const DEVICE_ID_KEY = "SUNSTAR_GUM_DEVICE_ID";

export const getDeviceId = () => {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY) || "";
  if (!deviceId) {
    deviceId = uuid();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }
  return deviceId;
};
